import axios from "axios";
import { APP_URL, API_URL } from "../config";

export const signInService = async (values) => {
    await axios.get(`${APP_URL}/sanctum/csrf-cookie`);
    return axios.post(`${API_URL}/login`, { ...values });
};

export const recoverPasswordService = async (values) => {
    await axios.get(`${APP_URL}/sanctum/csrf-cookie`);
    return axios.post(`${API_URL}/recover_password`, {...values});
};

export const resetPasswordService = async (values) => {
    return axios.post(`${API_URL}/reset_password`, {...values});
}
